import React from 'react';
import PropTypes from 'prop-types';

import DownloadIcon from '@mui/icons-material/Download';

import LoadingButton from '@mui/lab/LoadingButton';

import axios from '../axiosClient.js';
import useAlertSnackbar from '../hooks/useAlertSnackbar.jsx';

function ExportButton({
  url,
  filename,
  queryParams = {},
  disabled = false,
  buttonText = 'Export',
  'data-cy': dataCy,
}) {
  const [, setSnackbarError] = useAlertSnackbar('error', 0);
  const [loading, setLoading] = React.useState(false);

  const handleExportData = React.useCallback(async () => {
    setLoading(true);

    try {
      const response = await axios({
        method: 'GET',
        url,
        headers: {
          Accept: 'text/csv',
        },
        params: queryParams,
        responseType: 'blob',
      });

      const blob = new Blob([response.data], { type: 'text/csv' });

      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', filename);

      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (err) {
      setSnackbarError(err.response?.data?.error || err.message);
    }

    setLoading(false);
  }, [url, filename, queryParams, setSnackbarError]);

  return (
    <LoadingButton
      data-cy={dataCy}
      variant="contained"
      color="primary"
      loading={loading}
      disabled={disabled}
      onClick={handleExportData}
      startIcon={<DownloadIcon />}
      sx={{
        height: '50px',
        minWidth: '100px',
        fontSize: '1rem',
        padding: '0.5rem 1.5rem',
      }}
    >
      {buttonText}
    </LoadingButton>
  );
}

ExportButton.propTypes = {
  url: PropTypes.string.isRequired,
  filename: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  buttonText: PropTypes.string,
  'data-cy': PropTypes.string,
};

export default React.memo(ExportButton);
